import { stringify } from './stringifyHelpers';

export class LogHelpers {
  constructor(private prefix: string) {

  }

  log(content: any) {
    if (content instanceof HTMLElement) {
      console.log(`${this.prefix}`);
      console.log(content);
    } else {
      console.log(`${this.prefix} - ${stringify(content, null, 2, null)}`);
    }

  }
}